export default __webpack_public_path__ + "static/media/set_5_Image-4.c2c32fdb.svg";